import { Link } from "react-router";

export function MarketInsights() {
  return (
    <section id="insights" className="container insights-note" aria-labelledby="insights-heading">
      <div>
        <p className="section-kicker">Before you source</p>
        <h2 id="insights-heading">A clearer brief. More useful quotations.</h2>
      </div>
      <div>
        <p>Include the grade or model, quantity, destination and target delivery date in your enquiry. Compare offers on the same basis: specification, packing, delivery terms and payment conditions—not price alone.</p>
        <Link className="catalog-preview-link" to="/how-it-works">See how sourcing works <span aria-hidden="true">→</span></Link>
      </div>
    </section>
  );
}
